module.exports = __webpack_public_path__ + "static/media/time.063f7dbe.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icons/time.svg
// module id = 683
// module chunks = 0